import React, { useEffect, useRef, useState } from "react";

import styled from "styled-components";

import Alert from "components/atoms/alert/Alert";
import AbstractModal from "components/page/modal/AbstractModal";

const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const Label = styled.label`
    font-size: 12px;
    font-weight: 700;
    color: #253a50;
`;

const Input = styled.input`
    height: 36px;
    padding: 0 10px;
    border: 1px solid #d5dfea;
    border-radius: 8px;
    background: #ffffff;
    color: #24384d;
    font-size: 13px;

    &:focus {
        outline: none;
        border-color: #93a7bc;
        box-shadow: 0 0 0 3px rgba(15, 76, 129, 0.1);
    }
`;

const Hint = styled.div`
    color: #5d7389;
    font-size: 12px;
    line-height: 1.5;
`;

function ManuscriptNodeNameModal({ title, initialName, submitText, hint, exitModal, onSubmit }) {
    const [name, setName] = useState(initialName || "");
    const inputRef = useRef(null);

    useEffect(() => {
        inputRef.current?.focus();
        inputRef.current?.select();
    }, []);

    const submit = () => {
        const trimmedName = name.trim();
        if (!trimmedName) {
            Alert("warn", "에러", "이름을 입력해주세요.");
            return;
        }
        onSubmit?.(trimmedName);
    };

    const handleKeyDown = (event) => {
        if (event.nativeEvent?.isComposing || event.keyCode === 229) {
            return;
        }
        if (event.key === "Enter") {
            event.preventDefault();
            submit();
        }
    };

    return (
        <AbstractModal
            id="manuscript-node-name-modal"
            modalTitle={title}
            width={420}
            exitModal={exitModal}
            footer={{
                leftBtnText: "취소",
                leftOnClick: exitModal,
                rightBtnText: submitText,
                rightOnClick: submit,
                disabled: !name.trim(),
            }}
        >
            <Form
                onSubmit={(event) => {
                    event.preventDefault();
                    submit();
                }}
            >
                <Label htmlFor="manuscript-node-name-input">이름</Label>
                <Input
                    ref={inputRef}
                    id="manuscript-node-name-input"
                    aria-label="이름"
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                    onKeyDown={handleKeyDown}
                />
                {hint ? <Hint>{hint}</Hint> : null}
            </Form>
        </AbstractModal>
    );
}

export default ManuscriptNodeNameModal;
